import Vue from "vue"
import Vuex from "vuex"
import space from "./store/layout"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiUrl: process.env.VUE_APP_API
  },
  modules: {
    space
  }
})
